import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  errorContainer: {
    p: 3,
  },
  mainContainer: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(0.625),
    overflow: 'hidden',
    marginBottom: theme.spacing(2),
  },
  sectionDivider: {
    marginX: theme.spacing(3),
    marginY: theme.spacing(2),
    borderColor: theme.palette.grey[300],
  },
  dialogPaper: {
    borderRadius: theme.spacing(1),
    maxHeight: '90vh',
  },
});
